import type { KeyboardEventHandler, ReactNode } from "react";

import { Select, TextInput } from "../../ui";

export interface VariableValueFieldProps {
  allowedValues: readonly string[];
  disabled?: boolean;
  description?: string;
  emptyLabel?: string;
  error?: string | null;
  help?: ReactNode;
  label: string;
  onChange: (value: string) => void;
  onKeyDown?: KeyboardEventHandler<HTMLElement>;
  required?: boolean;
  value: string;
  // A stored revision may carry a value type this build does not know
  // (VariableRevisionResponse.value_type is VariableValueType | string), so
  // an unrecognised type renders the plain text control.
  valueType: string;
}

export function VariableValueField({
  allowedValues,
  disabled,
  description,
  emptyLabel,
  error,
  help,
  label,
  onChange,
  onKeyDown,
  required,
  value,
  valueType,
}: VariableValueFieldProps) {
  if (valueType === "bool" || valueType === "enum") {
    const options = valueType === "bool" ? ["true", "false"] : allowedValues;
    return (
      <Select
        description={description}
        disabled={disabled}
        error={error ?? undefined}
        help={help}
        label={label}
        required={required}
        value={value}
        onChange={(event) => {
          onChange(event.currentTarget.value);
        }}
      >
        {emptyLabel === undefined ? null : (
          <option value="">{emptyLabel}</option>
        )}
        {options.map((option) => (
          <option key={option} value={option}>
            {valueType === "bool"
              ? option === "true"
                ? "True"
                : "False"
              : option}
          </option>
        ))}
      </Select>
    );
  }
  return (
    <TextInput
      description={description}
      disabled={disabled}
      error={error ?? undefined}
      help={help}
      inputMode={valueType === "number" ? "decimal" : undefined}
      label={label}
      placeholder={emptyLabel}
      required={required}
      value={value}
      onKeyDown={onKeyDown}
      onChange={(event) => {
        onChange(event.currentTarget.value);
      }}
    />
  );
}
